import { render, staticRenderFns } from "./card-attribute.vue?vue&type=template&id=4ade7fb0&scoped=true"
import script from "./card-attribute.vue?vue&type=script&lang=js"
export * from "./card-attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade7fb0",
  null
  
)

export default component.exports